import "rxjs/add/operator/map";
import { stringify } from "querystring";
import { formatMessage } from "lib/globalize-util";
import { ActionsObservable } from "redux-observable";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import { INSIGHTS } from "constants/action-types";
import type { FetchProductBadgesAction } from "actions/insights/product-badges";
import { Observable } from "rxjs/Observable";
import type { IStore } from "reducers";
import type { IBadges } from "types/insights/product-badges";

export const fetchProductBadgesEpic = (action$: ActionsObservable<FetchProductBadgesAction>, store) =>
    action$.ofType(INSIGHTS.FETCH_BADGES.START).switchMap(({ payload }) => {
        const state: IStore = store.getState();
        const brandId = state.scope.brand._id;

        const query = {
            viewAsCompanyId: payload.viewAsCompanyId,
        };

        let url = "";

        if (payload.viewAsCompanyId) {
            url = `${siteConfig.orderInsightApi}/insights/brand/${brandId}/products/badges?${stringify(query)}`;
        } else {
            url = `${siteConfig.orderInsightApi}/insights/brand/${brandId}/products/badges`;
        }

        return ajax({
            url,
            method: "GET",
            withCredentials: true,
            crossDomain: true,
            headers: {
                "Content-Type": "application/json",
            },
            handle401: false,
        })
            .flatMap(({ response, status }) => {
                if (status !== 200) {
                    throw new Error(response.message || formatMessage("Unknown fetch error"));
                }
                const badges = response as IBadges;
                return [
                    {
                        type: INSIGHTS.FETCH_BADGES.COMPLETED,
                        badges: badges,
                    },
                ];
            })
            .catch((error) => {
                return Observable.merge(
                    Observable.of({
                        type: INSIGHTS.FETCH_BADGES.ERROR,
                        error: true,
                        payload: new Error("Error fetching product badges"),
                    })
                );
            });
    });
